export default "/images/MarioDiPasquantonio.jpg?041400706d95c149cd6762ce96863e08";